import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import tr from './locales/tr/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';
import ru from './locales/ru/translation.json';
import et from './locales/et/translation.json';
import de from './locales/de/translation.json';
import az from './locales/az/translation.json';
import kk from './locales/kk/translation.json';
import ky from './locales/ky/translation.json';
import tk from './locales/tk/translation.json';
import uz from './locales/uz/translation.json';
import fi from './locales/fi/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, tr: { translation: tr }, fr: { translation: fr }, it: { translation: it }, ru: { translation: ru }, et: { translation: et }, de: { translation: de }, az: { translation: az }, kk: { translation: kk }, ky: { translation: ky }, tk: { translation: tk }, uz: { translation: uz }, fi: { translation: fi } },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'dr.i18n.lng',
    },
  });

export default i18n;
